import React, {Component} from 'react';
import Title from '../base/title';
import api from '../../utils/api';

export default class Strategy extends Component {

  constructor(props) {
    super(props);
    this.state = {
      opened: true,
      loader: ' loader-box',
      strategy: {
        VPN: 3,
        Super: 2,
        VPD: 2,
        FD: 2
      }
    }
  }

  componentWillUnmount() {
   this._ismounted = false;
  }

  componentDidMount() {
    this._ismounted = true;
    let _self = this;
    api.get('product_strategies').then(resp => {
      let _strategy = {};
      resp.data.forEach(strategy => {
        _strategy[strategy.product.short_name] = strategy.difference
      });
      if (_self._ismounted) _self.setState({ strategy: _strategy, loader: '' });
    });
  }

  render() {
    let _self = this;
    return <div className="row">
        <Title isOpen={_self.state.opened} toggle={() => { _self.setState({ opened: !_self.state.opened }, function() { if (_self.state.opened) _self.componentDidMount(); }); }} text="ESTRATEGIA" isGray={true} hasIcon={true} />
        {this.state.opened && <div className="row">
          <div className="col s12">
            <div className="row">
              <div className={"marketShare" + this.state.loader}>
                <table className='c-table'>
                  <thead>
                    <tr>
                      <td>&nbsp;</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key} className={'center'}>{key}</td>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Diferencial País (%)</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key} className={'center'}>
                            <input readOnly='readonly' type="number"
                                   value={_self.state.strategy[key]}
                                   onChange={ ev => { _self.state.strategy[key] = ev.target.value;_self.setState(_self.state) }} />
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>}
      </div>
  }

}


// WEBPACK FOOTER //
// ./src/containers/analisis/strategy.js